import SubcontractorErpEdit from "./SubcontractorErpEdit";
import SubcontractorErpShow from "./SubcontractorErpShow";
import SubcontractorErpList from "./SubcontractorErpList";

export default {
  name: "subcontractorErps",
  list: SubcontractorErpList,
  show: SubcontractorErpShow,
  edit: SubcontractorErpEdit,
};
